<template>
  <v-app>
    <!-- Header -->
    <HeaderSection />

    <!-- Contenido de las páginas -->
    <router-view></router-view>

    <!-- Footer -->
    <FooterSection />

  </v-app>
</template>

<script>
import HeaderSection from '@/components/HeaderSection.vue';
import FooterSection from '@/components/FooterSection.vue';

export default {
  name: 'App',
  components: {
    HeaderSection,
    FooterSection,
  },
};
</script>

<style>
/* Estilos globales si es necesario */
</style>